// Browser wiring for the analytics contract. Single transport: window.dataLayer (production only).
import { isProductionHost } from "./consent";
import { getCurrentChoice } from "./consent-runtime";
import {
  createTracker,
  sanitizePageUrl,
  sanitizeReferrer,
  type AnalyticsPayload,
  type PageContext,
} from "./analytics";

type QaWin = { __seoevoAnalyticsQa?: AnalyticsPayload[]; dataLayer?: unknown[] };

let tracker: ReturnType<typeof createTracker> | null = null;
let qa = false;
let referrer: string | null = null;
let currentHref: string | null = null;

/** Called once on hydration; `?consent_qa=1` on preview hosts enables the in-memory test double. */
export function initAnalytics() {
  if (typeof window === "undefined" || tracker) return;
  try {
    if (!isProductionHost(window.location.hostname)) {
      if (new URLSearchParams(window.location.search).get("consent_qa") === "1") window.sessionStorage.setItem("seoevo_analytics_qa", "1");
      qa = window.sessionStorage.getItem("seoevo_analytics_qa") === "1";
    }
  } catch {
    qa = false;
  }
  referrer = sanitizeReferrer(document.referrer, window.location.host);
  currentHref = window.location.href;
  tracker = createTracker({
    analyticsGranted: () => getCurrentChoice()?.analytics === true,
    isProduction: () => isProductionHost(window.location.hostname),
    send: (p) => {
      const w = window as QaWin;
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push(p);
    },
    qaSink: qa
      ? (p) => {
          const w = window as QaWin;
          (w.__seoevoAnalyticsQa = w.__seoevoAnalyticsQa || []).push(p);
          console.info("[analytics-qa]", p.event_name, p);
        }
      : undefined,
    page: currentPage,
  });
}

function currentPage(): PageContext {
  return { href: window.location.href, title: document.title, referrer };
}

/** A real route change: the previous page (canonical, no query) becomes the referrer. */
export function noteRouteChange() {
  if (typeof window === "undefined") return;
  const next = window.location.href;
  if (currentHref && sanitizePageUrl(currentHref, { allowUtm: false }) !== sanitizePageUrl(next, { allowUtm: false })) {
    referrer = sanitizePageUrl(currentHref, { allowUtm: false });
  }
  currentHref = next;
}

export function getTracker() {
  if (!tracker) initAnalytics();
  return tracker;
}
